import React, { useState } from 'react'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import Resizer from "react-image-file-resizer";

const ImageInput = ({ classList, imageSRC, setImageSRC, imageInputRef, lableText, onImageSelect, URLs }) => {

    const [imageHoverState, setImageHoverState] = useState(false)

    const deleteImage = async e => {

        e.preventDefault();
        setImageSRC(null)
        console.log('delete function called')
        let res;
        try {
            res = await fetch(URLs.delete, { method: 'delete' });
        } catch (err) {
            console.warn(err.message)
        }
        const showWarning = (warning) => {

            clearInterval(sessionStorage.getItem("notification-warning-timeout"));
            document.querySelector(".notification-message").innerText = warning.message;
            document
                .querySelector(".notification-container")
                .classList.add(warning.color);

            const timeoutId = setTimeout(() => {
                document
                    .querySelector(".notification-container")
                    .classList.remove(warning.color);
            }, 2000);

            sessionStorage.setItem("notification-warning-timeout", timeoutId);
        }

        if (res?.status === 404) {
            return showWarning({
                message: 'No image found for this item',
                color: 'active-red'
            })
        }

        else if (!res?.ok)
            return showWarning({
                message: 'Failed to delete the image',
                color: 'active-red'
            })

        showWarning({
            message: 'Image deleted successfully',
            color: 'active-green'
        })
    }

    const compressImage = async e => {
        try {
            Resizer.imageFileResizer(
                e.target.files?.[0],        // file
                300, 300,                   // maxWidth, maxHeight
                "JPEG",                     // compressFormat
                100,                        // quality
                0,                          // rotation
                file => {                    // responseUriFunc
                    const img_src = URL.createObjectURL(file)
                    console.log(img_src);
                    setImageSRC(img_src)
                },
                "file",                     // outputType
                200, 200                    // minWidth, minHeight 
            );
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <div
            className={classList.container || 'image-container'}
            onMouseEnter={e => setImageHoverState(true)}
            onMouseLeave={e => setImageHoverState(false)}
        >
            <label htmlFor='img-input'>
                {!imageSRC
                    ? <span>{lableText}</span>
                    :
                    <img
                        src={imageSRC}
                        className={classList.img || 'image'}
                        alt='item'
                        width='148'
                        height='148'
                    />
                }
                <input ref={imageInputRef} type='file' id='img-input' accept="image/*" onChange={compressImage} style={{ display: 'none' }} />
            </label>
            {imageHoverState && imageSRC &&
                <div>
                    <DeleteOutlinedIcon className='img_delete_btn' onClick={deleteImage} />
                </div>
            }
        </div>
    )
}

export default ImageInput